// extracted by mini-css-extract-plugin
module.exports = {"button":"ManualWrite_button__p0qYD","comments":"ManualWrite_comments__3Pevr","desktop":"ManualWrite_desktop__175tc","mobile":"ManualWrite_mobile__1QHUQ"};